import script from "./SubCategorySelect.vue?vue&type=script&setup=true&lang=js"
export * from "./SubCategorySelect.vue?vue&type=script&setup=true&lang=js"

import "./SubCategorySelect.vue?vue&type=style&index=0&id=0ccc8faf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ccc8faf"]])

export default __exports__